require('./about/about_module.ts');
require('./about/about_routes.ts');
require('./about/commands/get_server_deploy_detials.ts');
require('./about/components/about_config/about_config.ts');
require('./about/components/about_device/about_device.ts');
require('./about/components/about_home/about_home.ts');
require('./about/components/about_release/about_release.ts');
require('./about/components/about_toggles/about_toggles.ts');
require('./about/servants/parse_dictionary_servant.ts');
require('./commands/edit_pronouns_command.ts');
require('./commands/get_pronouns_list_command.ts');
require('./components/settings_feature_list/settings_feature_list_component.ts');
require('./components/settings_feature_list/settings_feature_list_controller.ts');
require('./components/settings_welcome/settings_welcome_component.ts');
require('./components/settings_welcome/settings_welcome_controller.ts');
require('./datasources/pronouns_list_datasource.ts');
require('./queries/pronouns_list_query.ts');
require('./services/edit_pronouns_service.ts');
require('./services/settings_logout_configuration_service.ts');
require('./services/settings_state_configuration_service.ts');
require('./settings_configuration.ts');



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-settings/src/core.ts